import { DatalayerVirtualPageMapping } from "../libs/datalayer/hooks/use-datalayer-virtual-page";
import {
    ROUTE_APP_EMPTY,
    ROUTE_APP_QUOTATION,
    ROUTE_APP_SUMMARY,
} from "./routes/app";

export const appPagesMapping: DatalayerVirtualPageMapping = {
    [ROUTE_APP_EMPTY]: {
        pageName: "Seguro Vida Ley - Inicio",
        pagePath: "/seguro-vida-ley/inicio",
    },
    [ROUTE_APP_QUOTATION]: {
        pageName: "Seguro Vida Ley - Cotización",
        pagePath: "/seguro-vida-ley/cotizacion",
    },
    [ROUTE_APP_SUMMARY]: {
        pageName: "Seguro Vida Ley - Pago",
        pagePath: "/seguro-vida-ley/pago",
    },
};
